import { Box, Group, Skeleton, Space, Text, rem } from "@mantine/core";
import { PropertyType } from "../../types";
import PropertyTab from "../../components/tabs/PropertyTab";

type YourPropertiesProps = {
  useProperties: () => {
    properties: PropertyType[];
    loading: boolean;
    selectedPropertyId: string;
    handlePropertySelect: (propertyId: string) => void;
  };
};

export default function YourProperties({ useProperties }: YourPropertiesProps) {
  const { properties, loading, selectedPropertyId, handlePropertySelect } =
    useProperties();

  return (
    <Box>
      <Text c="#03045e" size="xl" fw={800}>
        Your properties
      </Text>
      <Space h={"xs"} />
      {loading ? (
        <Group>
          {[...Array.from({ length: 4 })]?.map((_, index) => (
            <Skeleton
              key={index}
              radius={"md"}
              p="md"
              h={rem(140)}
              w={rem(150)}
            />
          ))}
        </Group>
      ) : (
        <Group wrap="nowrap">
          {properties?.map((property, index) => (
            <PropertyTab
              key={index}
              propertyName={property.propertyName}
              id={property?.propertyId}
              numOfMeters={property?.smartMeterCount}
              totalConsumption={property.totalWaterConsumed}
              activeTab={selectedPropertyId === property?.propertyId}
              handlePropertySelect={handlePropertySelect}
            />
          ))}
        </Group>
      )}
    </Box>
  );
}
